module.exports = "<vue-component component=\"SignForm\" class=\"loginModalWrapper\" v-props=\"{ position: 'modal', formData: modalData }\"></vue-component>\n"